// ArmazenaVariaveisLogin.js

import ArmazenaVariaveis from './ArmazenaVariaveis.js';

class ArmazenaVariaveisLogin extends ArmazenaVariaveis {
  // Métodos adicionais específicos para a classe AppDataLogin, se necessário
 
}

export default ArmazenaVariaveisLogin;
